import AddUserModalForm from './container'

export default AddUserModalForm
